import { Effect } from 'redux-saga/effects';
import { select as typedSelect } from 'typed-redux-saga';

import { cloudApi } from '..';
import { getConfig } from '../../../features/config/selectors';

/**
 *
 */
export function* setTranslatorToken(): Generator<Effect, void> {
    const { dropTranslatorTokenHeader, translatorToken } = yield* typedSelect(getConfig);

    if (translatorToken && !dropTranslatorTokenHeader) {
        cloudApi.setHeader('X-Telemost-Translator-Token', translatorToken);
    }
}
